// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

/* 路由 */
import router from './router'
import store from './store'
/* axios */
import axios from './api'
import api from './api/api'
import 'lib-flexible/flexible'
// import './util/rem'
Vue.prototype.http = axios;
Vue.prototype.api = api;

/* swiper */
import 'swiper/dist/css/swiper.min.css';

/* 重置样式 */
import './assets/css/reset.min.css'

/* jquery */
import 'jquery'

/* bootstarp */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'

/* animate.css */
import 'animate.css'


/* 头部组件 */
import Header from './components/Header'
Vue.component(Header.name,Header)
/* 尾部组件 */
import Footer from './components/Footer'
Vue.component(Footer.name,Footer)

/* 回到顶部 */
import GoTop from './components/GoTop'
Vue.component(GoTop.name,GoTop)

Vue.config.productionTip = false
var surveyPage = ['/survey','/devHistory','/companyHonor','/culture','/orgStructure','/officemt']
var honorPage = ['/honor','/certification','/certificate','/designHonor','/engineeringHonor']
var engineeringPage = ['/engineering','/engineeringDetail','/engineeringDetail/','/building','/wall']
var joinPage = ['/join','/servicePolicy','/branch']
var newsPage = ['/news','/companyNews','/newsDetail']
var resPage = ['/resources','/ranks','/education','/recruit']
var contactPage = ['/contactUs','/map','/watchOut']
router.beforeEach((to, from, next) => {
    if(to.meta.title){
      document.title = to.meta.title
    }
    if(to.path == '/home'){
    	store.dispatch('app/setMenuIndex', 0)
    }else if(surveyPage.includes(to.path)){
    	store.dispatch('app/setMenuIndex', 1)
    }else if(honorPage.includes(to.path)){
    	store.dispatch('app/setMenuIndex', 2)
    }else if(engineeringPage.includes(to.path)){
    	store.dispatch('app/setMenuIndex', 3)
    }else if(joinPage.includes(to.path)){
    	store.dispatch('app/setMenuIndex', 4)
    }else if(newsPage.includes(to.path)){
    	store.dispatch('app/setMenuIndex', 5)
    }else if(resPage.includes(to.path)){
    	store.dispatch('app/setMenuIndex', 6)
    }else if(contactPage.includes(to.path)){
    	store.dispatch('app/setMenuIndex', 7)
    }
    next();
});


new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js